<template>
  <section id="layout-default">
    <div v-if="['md', 'lg'].includes($mq.current)" class="side-menu">
      <header>
        <router-link to="/customers"
          ><img src="~@/assets/img/logo_ordexa-white.svg" alt=""
        /></router-link>
      </header>
      <nav>
        <button :class="{ current: inSection('/dashboard') }" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'Dashboard' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 10.5 12 3l9 7.5"/><path d="M5 9.5V20a1 1 0 0 0 1 1h4v-6h4v6h4a1 1 0 0 0 1-1V9.5"/></svg>
          <span>Início</span>
        </button>
        <button :class="{ current: inSection('/customers', '/importar') }" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'Customers' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          <span>{{ $store.getters["Companies/customerTreatmentPlural"] }}</span>
        </button>
        <button :class="{ current: inSection('/tasks') }" v-if="usesTasks" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'TaskBoards' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m3 17 2 2 4-4"/><path d="m3 7 2 2 4-4"/><path d="M13 6h8M13 12h8M13 18h8"/></svg>
          <span>Tarefas</span>
        </button>
        <button :class="{ current: inSection('/agenda') }" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'Agenda' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
          <span>Agenda</span>
        </button>
        <button :class="{ current: inSection('/financeiro') }" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'Financeiro' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 12h.01M18 12h.01"/></svg>
          <span>Financeiro</span>
        </button>
        <button :class="{ current: inSection('/meu-site') }" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'MySite' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9.5"/><path d="M2.5 12h19"/><path d="M12 2.5a14.5 14.5 0 0 1 3.8 9.5 14.5 14.5 0 0 1-3.8 9.5 14.5 14.5 0 0 1-3.8-9.5A14.5 14.5 0 0 1 12 2.5z"/></svg>
          <span>Meu site</span>
        </button>
        <button :class="{ current: inSection('/ferramentas') }" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'Tools' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><path d="M17.5 14v7M14 17.5h7"/></svg>
          <span>Ferramentas</span>
        </button>
        <button :class="{ current: inSection('/calendar') }" v-if="usesTasks" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'Calendar' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/><path d="m9 16 2 2 4-4"/></svg>
          <span>Calendário de tarefas</span>
        </button>
        <button :class="{ current: inSection('/reports') }" class="nav-button item-dashboard" type="button" @click="$router.push({ name: 'Reports' })">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 3v18h18"/><path d="M18 17V9M13 17V5M8 17v-3"/></svg>
          <span>Relatórios</span>
        </button>
        <button :class="{ current: inSection('/activity-history') }"
          class="nav-button item-dashboard"
          type="button"
          @click="$router.push({ name: 'ActivityHistory' })"
        >
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 1 0 2.64-6.36L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l3.5 2"/></svg>
          <span>Histórico</span>
        </button>
        <button class="nav-button item-dashboard" type="button" @click="buttonModelsClick" :class="{ current: inSection('/note-templates', '/print-layout') }">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5Z"/><path d="M14 2v6h6"/><path d="M16 13H8M16 17H8M10 9H8"/></svg>
          <span>Modelos</span>
        </button>
        <div class="container-submenu">
          <button
            class="nav-button item-dashboard"
            type="button"
            @click="$router.push({ name: 'NoteTemplates' })"
          >
            Modelos de anotação
          </button>
          <button type="button" @click="$router.push({ name: 'PrintLayout' })">
            Layout de impressão
          </button>
        </div>
        <button class="nav-button item-dashboard" type="button" @click="buttonCompanyClick" :class="{ current: inSection('/business') }">
          <svg class="nav-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path d="M10 6h4M10 10h4M10 14h4M10 18h4"/></svg>
          <span>{{
            $store.getters["Companies/companyTreatmentSingular"]
          }}</span>
        </button>
        <div class="container-submenu">
          <button type="button" @click="$router.push({ name: 'BusinessMain' })">
            Geral
          </button>
          <button
            type="button"
            @click="$router.push({ name: 'BusinessUsers' })"
          >
            Usuários do Ordexa
          </button>
          <button type="button" @click="$router.push({ name: 'BusinessForm' })">
            Campos do formulário
          </button>
        </div>
      </nav>
      <footer>
        <div v-if="isFreePlan && inTrial" class="upgrade-cta-sidebar" @click="openUpgrade('trial')">
          <div class="upgrade-cta-top">
            <span class="upgrade-cta-label">Teste completo</span>
            <span class="upgrade-cta-action">Assinar →</span>
          </div>
          <div class="upgrade-cta-count">{{ trialDaysLeft }} dia{{ trialDaysLeft === 1 ? "" : "s" }} restante{{ trialDaysLeft === 1 ? "" : "s" }} com tudo liberado</div>
        </div>
        <div v-else-if="isFreePlan" class="upgrade-cta-sidebar" @click="openUpgrade('sidebar')">
          <div class="upgrade-cta-top">
            <span class="upgrade-cta-label">Plano Grátis</span>
            <span class="upgrade-cta-action">Assinar →</span>
          </div>
          <div class="upgrade-cta-bar">
            <div class="upgrade-cta-fill" :style="{ width: Math.min(100, usagePercent) + '%' }"></div>
          </div>
          <div class="upgrade-cta-count">{{ customersCount }} / {{ planCustomersLimit }} {{ customerTreatmentPlural.toLowerCase() }}</div>
        </div>
        <button
          type="button"
          class="btn-referral"
          @click="$router.push({ name: 'Referral' })"
        >
          🎁 Indique e ganhe 1 mês
        </button>
        <div>
          <button type="button" class="btn-help" @click="accessHelp">
            <img src="~@/assets/img/ico/ico_help_white.svg" alt="" />
            <span>Ajuda</span>
          </button>
          <button type="button" class="btn-suggest" @click="$eventbus.emit('Suggestion/open')">💡 Sugerir melhoria</button>
        </div>
        <div>&copy; Ordexa</div>
      </footer>
    </div>
    <div class="container-group-main">
      <header>
        <div class="col-left">
          <template v-if="['xs', 'sm'].includes($mq.current)">
            <button
              type="button"
              class="btn-hamburguer-menu"
              @click.stop="buttonHamburguerMenuClick"
            >
              <img src="~@/assets/img/ico/ico_hamburger_menu.svg" alt="" />
            </button>
            <router-link to="/customers">
              <img
                class="logo-ordexa"
                src="~@/assets/img/logo_ordexa.svg"
                alt=""
              />
            </router-link>
          </template>
        </div>
        <div class="col-right">
          <span
            v-if="env"
            class="container-environment-id"
            @click="containerEnvironmentIdClick"
          >
            <span v-if="['xs', 'sm'].includes($mq.current)">{{
              env.split("")[0]
            }}</span>
            <span v-else>{{ env }}</span>
          </span>
          <button
            type="button"
            class="btn-search"
            :title="`Buscar ${customerTreatmentPlural.toLowerCase()} (Ctrl+K)`"
            :aria-label="`Buscar ${customerTreatmentPlural.toLowerCase()}`"
            @click="$eventbus.emit('Search/open')"
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="m20 20-3.5-3.5" /></svg>
            <span v-if="!['xs', 'sm'].includes($mq.current)">Buscar {{ customerTreatmentPlural.toLowerCase() }}</span>
          </button>
          <button
            v-if="canWriteNotes"
            type="button"
            class="btn-quick-note"
            title="Ditar atendimento: fale, a IA escreve a anotação"
            @click="$eventbus.emit('QuickNote/open', { source: 'header' })"
          >
            🎙️<span v-if="!['xs', 'sm'].includes($mq.current)"> Ditar atendimento</span><span v-else> Ditar</span>
          </button>
          <ComponentNotificationsBell />
          <button
            ref="buttonUser"
            type="button"
            class="btn-user"
            aria-label="Menu da conta"
            aria-haspopup="menu"
            @click.stop="buttonUserClick"
          >
            <span class="profile-picture">
              <img :src="profilePictureUrl" alt="" />
            </span>
            <span v-if="['md', 'lg'].includes($mq.current)" class="user-name">{{
              userName
            }}</span>
            <img src="~@/assets/img/ico/ico_arrow_down.svg" alt="" />
          </button>
          <div
            ref="containerUserMenu"
            v-click-outside="containerUserMenuClickOutside"
            class="container-user-menu"
          >
            <button type="button" @click="buttonProfileClick">
              <span class="container-icon"
                ><img src="~@/assets/img/ico/ico_profile_dark.svg" alt=""
              /></span>
              <span class="label">Ver perfil</span>
            </button>

            <button
              v-if="isUserSystemAdmin || isUserStandard"
              type="button"
              @click="$router.push({ name: 'Reports' })"
            >
              <span class="container-icon"
                ><img src="~@/assets/img/ico/ico_reports_dark.svg" alt=""
              /></span>
              <span class="label">Relatórios</span>
            </button>

            <button v-else type="button" @click="buttonReportsClick">
              <span class="container-icon"
                ><img src="~@/assets/img/ico/ico_reports_dark.svg" alt=""
              /></span>
              <span class="label">Relatórios</span>
            </button>

            <button v-if="isUserSystemAdmin" type="button" @click="$router.push({ name: 'AdminPanel' })">
              <span class="container-icon"
                ><img src="~@/assets/img/ico/ico_reports_dark.svg" alt=""
              /></span>
              <span class="label">Gestão (admin)</span>
            </button>

            <button
              v-if="isUserSystemAdmin || isUserStandard"
              type="button"
              @click="$router.push({ name: 'BusinessSubscription' })"
            >
              <span class="container-icon"
                ><img src="~@/assets/img/ico/ico_payment_cards_dark.svg" alt=""
              /></span>
              <span class="label">Plano e Assinatura</span>
            </button>

            <button v-if="!inApp" type="button" @click="$router.push({ name: 'InstallApp', query: { de: 'menu' } })">
              <span class="container-icon">📱</span>
              <span class="label">Instalar o app no celular</span>
            </button>

            <button type="button" @click="$eventbus.emit('Suggestion/open')">
              <span class="container-icon">💡</span>
              <span class="label">Sugerir melhoria</span>
            </button>

            <button type="button" @click="buttonLogoutClick">
              <span class="container-icon"
                ><img src="~@/assets/img/ico/ico_sign_out_dark.svg" alt=""
              /></span>
              <span class="label">Sair</span>
            </button>
          </div>
        </div>
      </header>
      <div v-if="passwordChangeDue && $route.path !== '/personal-profile/password'" class="password-alert" role="status">
        <span v-if="passwordChangeReason === 'weak'">
          🔑 Sua senha é mais simples que o padrão atual. Crie uma nova até <strong>{{ passwordChangeDue }}</strong>.
        </span>
        <span v-else>🔑 Por segurança, crie uma nova senha até <strong>{{ passwordChangeDue }}</strong>.</span>
        <button type="button" @click="$router.push('/personal-profile/password')">Trocar senha</button>
      </div>
      <div v-if="billingAlert" class="billing-alert" :class="'alert-' + billingAlert.kind" role="alert">
        <span v-if="billingAlert.kind === 'payment_overdue'">
          ⚠️ Não identificamos o pagamento da sua assinatura. Sua conta continua no plano até <strong>{{ alertDate }}</strong>; regularizando até lá, nada muda.
        </span>
        <span v-else-if="billingAlert.kind === 'over_limit'">
          ⚠️ Sua conta tem {{ billingAlert.customers }} {{ customerTreatmentPlural.toLowerCase() }}, acima do limite de {{ billingAlert.limit }} do plano Grátis.
          Regularize até <strong>{{ alertDate }}</strong>; depois, a conta entra em modo consulta.
        </span>
        <span v-else>
          🔒 Conta em modo consulta: seus dados continuam disponíveis, mas novas anotações exigem um plano.
        </span>
        <button v-if="billingAlert.kind === 'payment_overdue' && billingAlert.url" type="button" @click="openInvoice(billingAlert.url)">Pagar agora</button>
        <button v-else-if="billingAlert.kind === 'payment_overdue'" type="button" @click="openUpgrade('payment_overdue', '', null, planIdentifier)">Pagar agora</button>
        <button v-else type="button" @click="openUpgrade('customers_limit')">Regularizar</button>
      </div>
      <div v-else-if="showHabitBanner" class="plan-banner habit-banner">
        <span v-if="!trialUsage.patients">
          <template v-if="!isMobile">Teste completo: <strong>{{ trialDaysLeft }} dias</strong>. </template>Para começar, dite o último atendimento<template v-if="!isMobile">: a IA cria a ficha e escreve a anotação</template>.
        </span>
        <span v-else>
          <span class="habit-dots" aria-hidden="true"><i v-for="n in 3" :key="n" :class="{ on: n <= noteDays }"></i></span>
          Anotações em <strong>{{ noteDays }} de 3 dias</strong><template v-if="!isMobile">. O ritmo vem de anotar logo depois de cada atendimento</template>.
        </span>
        <button type="button" @click="habitDitar">Ditar atendimento</button>
      </div>
      <div v-else-if="showPlanBanner" class="plan-banner" :class="{ urgent: inTrial && trialDaysLeft <= 2 }">
        <span v-if="pendingInvoiceUrl">
          Sua assinatura está aguardando pagamento.
        </span>
        <span v-else-if="inTrial">
          Você está no teste completo do Ordexa: <strong>{{ trialDaysLeft }} dia{{ trialDaysLeft === 1 ? "" : "s" }}</strong> restante{{ trialDaysLeft === 1 ? "" : "s" }}<template v-if="trialUsageText && trialDaysLeft <= 7">
            · {{ trialUsageText.toLowerCase() }}</template><template v-else-if="!['xs', 'sm'].includes($mq.current)">
            · IA em todos os atendimentos, {{ customerTreatmentPlural.toLowerCase() }} ilimitados e até 3 usuários</template><template v-if="trialAiLimit && trialAiUsed / trialAiLimit >= 0.5">
            · IA do teste: <strong>{{ trialAiUsed }} de {{ trialAiLimit }}</strong> ações</template><template v-if="minutesSaved >= 10">
            · a IA já te poupou <strong>~{{ minutesSavedLabel }}</strong></template>.<template v-if="welcomeOfferActive">
            <strong>50% no 1º mês</strong> até {{ welcomeOfferLabel }}.</template>
        </span>
        <span v-else-if="welcomeOfferActive">
          Seu teste terminou<template v-if="trialUsageText">. {{ trialUsageText }} aqui</template>.
          Oferta de boas-vindas até <strong>{{ welcomeOfferLabel }}</strong>: <strong>50% no 1º mês</strong>.
        </span>
        <span v-else-if="aiQuotaLimit && aiQuotaUsed / aiQuotaLimit >= 0.5">
          Plano Grátis: <strong>{{ aiQuotaUsed }} de {{ aiQuotaLimit }}</strong> ações de IA do mês usadas. No Consultório são 50 por dia.
        </span>
        <span v-else>
          Plano Grátis: {{ customersCount }} de {{ planCustomersLimit }} {{ customerTreatmentPlural.toLowerCase() }} usados.
        </span>
        <button type="button" @click="openUpgrade(pendingInvoiceUrl ? 'pending' : inTrial ? 'trial' : welcomeOfferActive ? 'welcome_offer' : 'banner')">
          {{ pendingInvoiceUrl ? "Concluir pagamento" : welcomeOfferActive ? "Assinar com 50%" : ['xs', 'sm'].includes($mq.current) ? "Assinar" : "Assinar a partir de R$ 39,90" }}
        </button>
      </div>
      <div
        ref="containerRouterView"
        class="container-router-view"
        @scroll="containerRouterViewScroll"
      >
        <div
          v-if="['xs', 'sm'].includes($mq.current) && mobileMenu.show"
          v-click-outside="containerMobileMenuClickOutside"
          class="container-mobile-menu"
          @click="containerMobileMenuClick"
        >
          <nav>
            <button type="button" @click="$router.push({ name: 'Dashboard' })">
              <svg class="m-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="9" rx="1.5"/><rect x="14" y="3" width="7" height="5" rx="1.5"/><rect x="14" y="12" width="7" height="9" rx="1.5"/><rect x="3" y="16" width="7" height="5" rx="1.5"/></svg>
              <span>Dashboard</span>
            </button>
            <button type="button" @click="$router.push({ name: 'Customers' })">
              <img src="~@/assets/img/ico/ico_clients.svg" alt="" />
              <span>{{
                $store.getters["Companies/customerTreatmentPlural"]
              }}</span>
            </button>
            <button v-if="usesTasks" type="button" @click="$router.push({ name: 'TaskBoards' })">
              <img src="~@/assets/img/ico/ico_checkbox-white.svg" alt="" />
              <span>Tarefas</span>
            </button>
            <button type="button" @click="$router.push({ name: 'Agenda' })">
              <img src="~@/assets/img/ico/ico_type_date.svg" alt="" />
              <span>Agenda</span>
            </button>
            <button type="button" @click="$router.push({ name: 'Financeiro' })">
              <img src="~@/assets/img/ico/ico_payment_cards_dark.svg" alt="" />
              <span>Financeiro</span>
            </button>
            <button type="button" @click="$router.push({ name: 'MySite' })">
              <svg class="m-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="6.5" y="2" width="11" height="20" rx="2"/><circle cx="12" cy="8" r="2"/><path d="M9 13h6M9 16h6"/></svg>
              <span>Meu site</span>
            </button>
            <button type="button" @click="$router.push({ name: 'Tools' })">
              <svg class="m-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><path d="M17.5 14v7M14 17.5h7"/></svg>
              <span>Ferramentas</span>
            </button>
            <button v-if="usesTasks" type="button" @click="$router.push({ name: 'Calendar' })">
              <img src="~@/assets/img/ico/ico_type_date.svg" alt="" />
              <span>Calendário de tarefas</span>
            </button>
            <button type="button" @click="$router.push({ name: 'Reports' })">
              <svg class="m-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 20V10M10 20V4M16 20v-7M22 20H2"/></svg>
              <span>Relatórios</span>
            </button>
            <button
              type="button"
              @click="$router.push({ name: 'ActivityHistory' })"
            >
              <svg class="m-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>
              <span>Histórico</span>
            </button>
            <button v-if="!inApp" type="button" @click="$router.push({ name: 'InstallApp', query: { de: 'menu' } })">
              <svg class="m-ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="7" y="2.5" width="10" height="19" rx="2"/><path d="M11 18.5h2"/></svg>
              <span>Instalar o app</span>
            </button>
            <button type="button" class="mobile-referral" @click="$router.push({ name: 'Referral' })">
              <span class="gift">🎁</span>
              <span>Indique e ganhe 1 mês</span>
            </button>
            <button type="button" @click.stop="buttonModelsClick">
              <img src="~@/assets/img/ico/ico_models.svg" alt="" />
              <span>Modelos</span>
            </button>
            <div class="container-submenu">
              <button
                type="button"
                @click="$router.push({ name: 'NoteTemplates' })"
              >
                Modelos de anotação
              </button>
              <button
                type="button"
                @click="$router.push({ name: 'PrintLayout' })"
              >
                Layout de impressão
              </button>
            </div>
            <button type="button" @click.stop="buttonCompanyClick">
              <img src="~@/assets/img/ico/ico_company.svg" alt="" />
              <span>{{
                $store.getters["Companies/companyTreatmentSingular"]
              }}</span>
            </button>
            <div class="container-submenu">
              <button
                type="button"
                @click="$router.push({ name: 'BusinessMain' })"
              >
                Geral
              </button>
              <button
                type="button"
                @click="$router.push({ name: 'BusinessUsers' })"
              >
                Usuários do Ordexa
              </button>
              <button
                type="button"
                @click="$router.push({ name: 'BusinessForm' })"
              >
                Campos do formulário
              </button>
            </div>
            <button type="button" @click="accessHelp">
              <span>Ajuda</span>
            </button>
            <button type="button" @click="$eventbus.emit('Suggestion/open')">
              <span>💡 Sugerir melhoria</span>
            </button>
          </nav>
        </div>
        <ComponentNextStep />
        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </div>
    </div>

    <!-- Global Search Component -->
    <GlobalSearch ref="globalSearch" />

    <ComponentFeedbackModal
      :visible="feedbackVisible"
      @close="feedbackDismissed = true"
      @wants-upgrade="feedbackDismissed = true; openUpgrade('trial')"
    />

    <ComponentReferralMoment />
    <ComponentQuickNote />
    <ComponentMilestone />
    <ComponentNeedsSurvey />
    <!-- Global upgrade/checkout modal (open with $eventbus.emit("Upgrade/open", { reason })) -->
    <ComponentUpgradeModal
      :visible="upgrade.visible"
      :reason="upgrade.reason"
      :limit-message="upgrade.message"
      :preselect="upgrade.preselect"
      :plan-known="upgrade.planKnown"
      @close="upgrade.visible = false"
      @upgrade-success="upgradeSuccess"
    />
    <ComponentSuggestionModal />
  </section>
</template>

<script>
import { firstName } from "@/utils/personName";
import MixinLayout from "@/mixins/MixinLayout.js";
import GlobalSearch from "@/components/GlobalSearch";
import ComponentUpgradeModal from "@/components/Billing/ComponentUpgradeModal";
import { track } from "@/utils/analytics";
import { claimNudge } from "@/utils/nudges";
import { isApp } from "@/utils/appInstall";
import ComponentReferralMoment from "@/components/Billing/ComponentReferralMoment";
import ComponentQuickNote from "@/components/ComponentQuickNote";
import ComponentNextStep from "@/components/Onboarding/ComponentNextStep";
import ComponentMilestone from "@/components/ComponentMilestone";
import ComponentFeedbackModal from "@/components/Billing/ComponentFeedbackModal";
import ComponentNeedsSurvey from "@/components/ComponentNeedsSurvey";
import ComponentNotificationsBell from "@/components/ComponentNotificationsBell";
import ComponentSuggestionModal from "@/components/ComponentSuggestionModal.vue";

// ?plano= values accepted in e-mail links.
const PLAN_LINKS = {
  consultorio: "lean",
  consultorio_anual: "lean_yearly",
  clinica: "team",
  clinica_anual: "team_yearly",
  lean: "lean",
  lean_yearly: "lean_yearly",
  team: "team",
  team_yearly: "team_yearly",
};
// Reasons whose person already decided or hit a wall: go straight to payment with Consultório.
const ONE_STEP_REASONS = ["trial", "welcome_offer", "ai_limit", "link"];

export default {
  name: "LayoutDefault",
  components: {
    ComponentReferralMoment,
    ComponentQuickNote,
    ComponentNextStep,
    ComponentMilestone,
    GlobalSearch,
    ComponentUpgradeModal,
    ComponentFeedbackModal,
    ComponentNeedsSurvey,
    ComponentNotificationsBell,
    ComponentSuggestionModal,
  },
  mixins: [MixinLayout], //unmounted
  beforeRouteEnter(to, from, next) {
    next((vm) => {});
  }, //beforeRouteEnter
  beforeRouteUpdate(to, from, next) {
    next();
  }, //beforeRouteUpdate
  beforeRouteLeave(to, from, next) {
    next();
  },
  props: [], //components
  data() {
    return {
      inApp: isApp(),
      mobileMenu: {
        show: false,
      },
      feedbackDismissed: false,
      upgrade: {
        visible: false,
        reason: "",
        message: "",
        preselect: "lean",
        onSuccess: null,
      },
    };
  }, //data
  computed: {
    accountType() {
      return this.user?.account_type || null;
    },

    companyId() {
      return this.$store.getters["App/companyId"];
    },

    company() {
      return this.$store.getters["Companies/company"];
    },

    env() {
      const vueAppEnv = process.env.VUE_APP_ENV;

      let ret = false;

      if (vueAppEnv) {
        if (vueAppEnv !== "production") {
          ret = vueAppEnv;
        }
      } else {
        ret = "not set";
      }

      return ret;
    },

    isUserStandard() {
      return this.user.account_type === "standard";
    },

    // Only full accounts write notes (the API refuses limited users).
    canWriteNotes() {
      return this.user?.account_type === "standard";
    },

    isUserSystemAdmin() {
      return this.user.account_type === "system_admin";
    },

    planAndMembershipLinkUrl() {
      return process.env.VUE_APP_API_BASE_URL + "/billing/plan";
    },

    profilePictureUrl() {
      if (this.user.image_url) {
        return this.user.image_url;
      } else {
        return require("@/assets/img/ico/ico_profile.svg");
      }
    },

    user() {
      return this.$store.getters["App/user"];
    },

    userName() {
      return firstName(this.user && this.user.name);
    },

    isFreePlan() {
      return this.$store.getters["Companies/isFreePlan"];
    },

    planCustomersLimit() {
      return this.$store.getters["Companies/planCustomersLimit"];
    },

    customersCount() {
      return this.$store.getters["Companies/customersCount"];
    },

    customerTreatmentPlural() {
      return this.$store.getters["Companies/customerTreatmentPlural"] || "Clientes";
    },

    inTrial() {
      return this.$store.getters["Companies/inTrial"];
    },

    trialDaysLeft() {
      return this.$store.getters["Companies/trialDaysLeft"];
    },

    pendingInvoiceUrl() {
      return this.$store.getters["Companies/pendingInvoiceUrl"];
    },

    planIdentifier() {
      return this.$store.getters["Companies/planIdentifier"] || "lean";
    },

    aiQuotaUsed() {
      return (this.company && this.company.ai_quota_used) || 0;
    },

    aiQuotaLimit() {
      return (this.company && this.company.ai_quota_limit) || 0;
    },

    minutesSaved() {
      return (this.company && this.company.ai_minutes_saved_total) || 0;
    },

    welcomeOfferActive() {
      return !!(this.company && this.company.welcome_offer_active);
    },

    trialAiLimit() {
      return (this.company && this.company.trial_ai_limit) || 0;
    },

    trialAiUsed() {
      return (this.company && this.company.trial_ai_used) || 0;
    },

    welcomeOfferLabel() {
      const d = this.company && this.company.welcome_offer_until;
      return d ? new Date(d).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) : "";
    },

    // What the account really did during the trial ("3 pacientes e 8 anotações").
    trialUsageText() {
      const u = this.company && this.company.trial_usage;
      if (!u || !(u.patients || u.notes)) return "";
      const t = (this.$store.getters["Companies/customerTreatmentSingular"] || "paciente").toLowerCase();
      const parts = [];
      if (u.patients) parts.push(`${u.patients} ${u.patients === 1 ? t : this.customerTreatmentPlural.toLowerCase()}`);
      if (u.notes) parts.push(`${u.notes} ${u.notes === 1 ? "anotação" : "anotações"}`);
      return `Você já tem ${parts.join(" e ")}`;
    },

    minutesSavedLabel() {
      const m = this.minutesSaved;
      if (m < 60) return `${m} min`;
      const h = Math.floor(m / 60), r = m % 60;
      return r ? `${h}h${String(r).padStart(2, "0")}` : `${h}h`;
    },

    canManageBilling() {
      return !!(this.user && (this.user.billing_admin || this.isUserSystemAdmin));
    },

    // Ask once, right after the trial ended, why the user didn't subscribe
    feedbackVisible() {
      const c = this.company;
      return !!(
        c &&
        !this.feedbackDismissed &&
        !this.upgrade.visible &&
        this.canManageBilling &&
        this.isFreePlan &&
        !this.inTrial &&
        c.trial_ends_at &&
        !c.feedback_asked
      );
    },

    usesTasks() {
      const c = this.$store.state.Companies.company || {};
      return c.uses_tasks !== false;
    },
    passwordChangeDue() {
      const user = this.$store.getters["App/user"] || {};
      const due = user.password_change_due_at;
      if (!due || new Date(due) <= new Date()) return null;
      return new Date(due).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
    },
    passwordChangeReason() {
      return (this.$store.getters["App/user"] || {}).password_change_reason;
    },
    billingAlert() {
      const c = this.$store.state.Companies.company || {};
      return c.billing_alert || null;
    },
    alertDate() {
      const d = this.billingAlert && this.billingAlert.deadline;
      return d ? new Date(d.length === 10 ? `${d}T12:00:00` : d).toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" }) : "";
    },
    trialUsage() {
      return (this.company && this.company.trial_usage) || {};
    },
    noteDays() {
      return Math.min(this.trialUsage.note_days || 0, 3);
    },
    isMobile() {
      return ["xs", "sm"].includes(this.$mq.current);
    },
    // Start of the trial: the bar guides to the daily habit (first patient, notes on 3 different
    // days). The plans come up once the habit is there, near the end of the trial, or when the
    // trial AI is running out.
    showHabitBanner() {
      if (!this.inTrial || !this.canWriteNotes || this.pendingInvoiceUrl || this.welcomeOfferActive || this.trialDaysLeft <= 3) return false;
      if (this.$route.query.guide) return false; // the "Próximo passo" card already says what to do
      if (this.trialAiLimit && this.trialAiUsed / this.trialAiLimit >= 0.8) return false;
      return (this.trialUsage.note_days || 0) < 3;
    },
    showPlanBanner() {
      if (!this.isFreePlan || !this.canManageBilling) return false;
      if (this.pendingInvoiceUrl) return true;
      if (this.inTrial && this.$route.query.guide) return false; // one call to action at a time, right after the onboarding
      if (this.inTrial || this.welcomeOfferActive) return true;
      return this.usagePercent >= 60 || (this.aiQuotaLimit && this.aiQuotaUsed / this.aiQuotaLimit >= 0.5);
    },

    usagePercent() {
      if (!this.planCustomersLimit || this.planCustomersLimit === 0) return 0;
      return Math.round((this.customersCount / this.planCustomersLimit) * 100);
    },
  }, //methods
  watch: {
    // E-mail links with ?ditar=1 open "Ditar atendimento" right away, once the user is loaded.
    "$route.query.ditar": {
      immediate: true,
      handler() {
        this.openQuickNoteFromLink();
      },
    },
    canWriteNotes() {
      this.openQuickNoteFromLink();
    },
    // E-mail links with ?plano=consultorio open the checkout with that plan, once the company is loaded.
    "$route.query.plano": {
      immediate: true,
      handler() {
        this.openPlanFromLink();
      },
    },
    company() {
      this.openPlanFromLink();
      this.openShareAfterLogin();
    },
    $route: function (value, oldValue) {
      this.mobileMenu.show = false;
    },

    // The company (plan, trial, limits) lives only in memory: reload it after a
    // page refresh, once the view has restored the user from localStorage.
    // Last day of the trial only: open the plans once, for accounts that really wrote notes (for the
    // others the banner keeps pointing to the first note). Two days before the end the trial_ending
    // e-mail, the bar and the notification already speak; the modal on top would be a fourth push.
    trialDaysLeft(days) {
      if (!this.inTrial || !days || days > 1 || !this.canManageBilling) return;
      if (!(this.trialUsage.notes > 0) || !claimNudge()) return;
      this.openUpgrade("trial", `Seu teste completo termina em ${days} dia${days === 1 ? "" : "s"}. Assine para manter a IA e os ${this.customerTreatmentPlural.toLowerCase()} ilimitados.`);
    },

    companyId: {
      immediate: true,
      handler(id) {
        if (id && !this.company) {
          this.$store.dispatch("Companies/loadCompany").catch(() => {});
        }
      },
    },
  }, //watch
  created() {
    // Store handler for cleanup
    this.handleScrollTo = (obj) => {
      this.$refs.containerRouterView.scrollTo(obj);
    };
    this.$eventbus.on("ContainerRouterView/scrollTo", this.handleScrollTo);

    this.handleUpgradeOpen = (payload = {}) => {
      this.openUpgrade(payload.reason, payload.message, payload.onSuccess, payload.plan);
    };
    this.$eventbus.on("Upgrade/open", this.handleUpgradeOpen);
  }, //created
  mounted() {}, //mounted
  updated() {}, //updated
  unmounted() {
    // Clean up event bus listener
    if (this.handleScrollTo) {
      this.$eventbus.off("ContainerRouterView/scrollTo", this.handleScrollTo);
    }
    if (this.handleUpgradeOpen) {
      this.$eventbus.off("Upgrade/open", this.handleUpgradeOpen);
    }
  }, //computed
  methods: {
    // Side menu: highlights the section of the current page (also on its sub-pages, e.g. a patient's page).
    inSection(...prefixes) {
      const path = this.$route.path || "";
      return prefixes.some((p) => path === p || path.startsWith(p + "/"));
    },
    habitDitar() {
      track("habit_banner_click", { note_days: this.trialUsage.note_days || 0 });
      this.$eventbus.emit("QuickNote/open", { source: "habit_banner" });
    },
    openQuickNoteFromLink() {
      if (!this.$route.query.ditar || !this.canWriteNotes) return;
      this.$nextTick(() => this.$eventbus.emit("QuickNote/open", { source: "link" }));
      const query = { ...this.$route.query };
      delete query.ditar;
      this.$router.replace({ query }).catch(() => {});
    },
    // Shared files arrived while signed out (router saved the flag): back to /compartilhar once signed in.
    openShareAfterLogin() {
      let pending = null;
      try {
        pending = localStorage.getItem("ordexa/pending-share");
        if (pending) localStorage.removeItem("ordexa/pending-share");
      } catch (e) {
        pending = null;
      }
      if (pending && this.$route.path !== "/compartilhar") this.$router.push("/compartilhar").catch(() => {});
    },
    openPlanFromLink() {
      let wanted = this.$route.query.plano;
      if (!wanted) {
        try {
          wanted = localStorage.getItem("ordexa/pending-plan");
        } catch (e) {
          wanted = null;
        }
      }
      if (!wanted || !this.company) return;
      const plan = PLAN_LINKS[String(wanted).toLowerCase()];
      try {
        localStorage.removeItem("ordexa/pending-plan");
      } catch (e) {
        // ignore
      }
      if (this.$route.query.plano) {
        const query = { ...this.$route.query };
        delete query.plano;
        this.$router.replace({ query }).catch(() => {});
      }
      // Paid accounts already have a plan: the plans page is enough.
      if (!plan || !this.isFreePlan) return;
      track("plan_link_open", { plan, utm_campaign: this.$route.query.utm_campaign || "" });
      this.openUpgrade(this.inTrial ? "trial" : this.welcomeOfferActive ? "welcome_offer" : "link", "", null, plan);
    },
    openInvoice(url) {
      window.open(url, "_blank", "noopener");
    },

    openUpgrade(reason = "", message = "", onSuccess = null, plan = null) {
      track("upgrade_open", { reason: reason || "other", can_manage: !!this.canManageBilling });
      if (!this.canManageBilling) {
        this.$eventbus.emit("ComponentToast/add", {
          autoHide: true,
          content: "Peça ao administrador da conta para assinar um plano.",
          type: "info",
        });
        return;
      }
      const chosen = plan || (ONE_STEP_REASONS.includes(reason) && !this.pendingInvoiceUrl ? "lean" : null);
      this.upgrade = { visible: true, reason, message, onSuccess, preselect: chosen || "lean", planKnown: !!chosen };
    },

    upgradeSuccess() {
      const callback = this.upgrade.onSuccess;
      this.upgrade.visible = false;
      if (typeof callback === "function") callback();
    },

    accessHelp() {
      window.open("https://ordexa.com.br/ajuda/", "_blank", "noopener");
    },

    closeUserMenu(e) {
      const elButton = this.$refs.buttonUser;
      const elMenu = elButton.nextSibling;

      elButton.classList.remove("active");
      elMenu.classList.remove("active");
    },

    openCloseSubmenu(e) {
      const elButton = e.currentTarget;
      const elSubmenu = elButton.nextSibling;

      if (elSubmenu.classList.contains("active")) {
        elButton.classList.remove("active");
        elSubmenu.classList.remove("active");
      } else {
        elButton.classList.add("active");
        elSubmenu.classList.add("active");
      }
    },

    openCloseUserMenu(e) {
      const elButton = this.$refs.buttonUser;
      const elMenu = elButton.nextSibling;

      if (elMenu.classList.contains("active")) {
        elButton.classList.remove("active");
        elMenu.classList.remove("active");
      } else {
        elButton.classList.add("active");
        elMenu.classList.add("active");
      }

      elMenu.style.left =
        elButton.getBoundingClientRect().right -
        elMenu.getBoundingClientRect().width +
        "px";
      elMenu.style.top =
        elButton.getBoundingClientRect().height +
        elButton.getBoundingClientRect().top +
        12 +
        "px";
    },

    //Events

    buttonHamburguerMenuClick(e) {
      this.closeUserMenu();
      this.mobileMenu.show = !this.mobileMenu.show;
    },

    buttonModelsClick(e) {
      this.openCloseSubmenu(e);
    },

    buttonCompanyClick(e) {
      this.openCloseSubmenu(e);
    },

    buttonUserClick(e) {
      this.mobileMenu.show = false;
      this.openCloseUserMenu();
    },

    buttonProfileClick(e) {
      this.openCloseUserMenu(e);
      this.$router.push(
        { name: "PersonalProfile" },
        () => {},
        (error) => {},
      );
    },

    buttonLogoutClick(e) {
      this.$store.dispatch("App/logout");

      this.$router.replace(
        { name: "Login" },
        () => {},
        () => {},
      );

      this.$eventbus.emit("ComponentToast/add", {
        autoHide: true,
        content: "Sessão finalizada com segurança",
        icon: null,
        showCloseButton: false,
        type: "success",
      });
    },

    buttonReportsClick(e) {
      this.$eventbus.emit("ComponentToast/add", {
        autoHide: true,
        content:
          "Você não tem acesso aos relatórios. Solicite este acesso a um usuário administrador.",
        icon: null,
        showCloseButton: false,
        type: "warning",
      });
    },

    containerEnvironmentIdClick(e) {
      e.currentTarget.style.display = "none";
    },

    containerMobileMenuClick(e) {
      this.mobileMenu.show = false;
    },

    containerMobileMenuClickOutside(e) {
      this.mobileMenu.show = false;
    },

    containerRouterViewScroll(e) {
      this.$eventbus.emit("ContainerRouterView/scroll", {
        e,
        containerRouterView: this.$refs.containerRouterView,
        scrollTop: this.$refs.containerRouterView.scrollTop,
      });
    },

    containerUserMenuClickOutside(e) {
      this.closeUserMenu();
    },
  }, //beforeRouteLeave
};
</script>

<style scoped>
#layout-default {
  display: flex;

  height: 100vh;
  /* dvh: on phones 100vh is taller than the visible area (browser bars), which hid the bottom of every page */
  height: 100dvh;
  overflow: hidden;
  /* clip, unlike hidden, cannot be scrolled by focus or scrollIntoView, so the
     sidebar and header never slide out of place. */
  overflow: clip;
  width: 100vw;
}

header {
  height: 66px;
  min-height: 66px;
}

.side-menu {
  flex: 2;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background: linear-gradient(180deg, #4a4a4a 0%, #555 100%);
  max-width: 300px;
  min-width: 230px;
  overflow-x: hidden;
  overflow-y: auto;
  box-shadow: 2px 0 12px rgba(0, 0, 0, 0.1);
}

.side-menu header {
  display: flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;
  padding: 1.2rem;
}

.side-menu nav {
  flex: 1;
}

.side-menu nav button {
  background-color: transparent;
  border: none;
  color: #fff;
  margin: 0;
  padding: 0;
  width: 100%;
}

.side-menu nav > button {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 2px 10px;
  width: calc(100% - 20px);
  padding: 0.72rem 1rem;
  border-left: 3px solid transparent;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.86);
  font-size: 0.98em;
  text-align: left;
  transition: background-color 0.15s ease, color 0.15s ease;
}

.side-menu nav > button:hover {
  background-color: rgba(255, 255, 255, 0.07);
  color: #fff;
}

.side-menu nav > button.active,
.side-menu nav > button.current {
  background-color: rgba(41, 177, 204, 0.18);
  border-left-color: #29b1cc;
  color: #fff;
  font-weight: 600;
}

.side-menu nav > button .nav-ico {
  flex: none;
  width: 22px;
  height: 22px;
  color: inherit;
}

.side-menu nav > button.current .nav-ico {
  color: #6fd3e8;
}

.side-menu footer {
  box-sizing: border-box;
  color: #fff;
  font-size: 0.9em;
  padding: 1.2rem;
  text-align: center;
}

.side-menu footer > div {
  margin-top: 1.5em;
}

.btn-referral {
  display: block;
  width: 100%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.18);
  color: #fff;
  border-radius: 8px;
  padding: 0.55em 0.8em;
  margin-bottom: 0.6em;
  font-size: 0.85em;
  cursor: pointer;
}

.btn-referral:hover {
  background: rgba(255, 255, 255, 0.16);
}

.password-alert {
  align-items: center;
  background: #fff4e0;
  color: #7a4f00;
  display: flex;
  flex-wrap: wrap;
  font-size: 0.9em;
  gap: 12px;
  justify-content: center;
  padding: 8px 16px;
  text-align: center;
}

.password-alert button {
  background: #a86600;
  border: 0;
  border-radius: 4px;
  color: #fff;
  cursor: pointer;
  padding: 4px 12px;
}

.billing-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
  background: #c62828;
  color: #fff;
  padding: 8px 16px;
  font-size: 0.9em;
  text-align: center;
}

.billing-alert.alert-over_limit {
  background: #d84315;
}

.billing-alert button {
  background: #fff;
  color: #c62828;
  border: none;
  border-radius: 6px;
  padding: 5px 14px;
  font-weight: 700;
  cursor: pointer;
  height: auto;
}

.plan-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.6em 1em;
  background: #e8f7fa;
  border-bottom: 1px solid #c4e9f1;
  color: #1d5f6e;
  font-size: 0.88em;
  padding: 0.55em 1em;
  text-align: center;
}

@media (max-width: 640px) {
  .plan-banner,
  .billing-alert {
    font-size: 0.8em;
    padding: 0.4em 0.8em;
    gap: 0.4em 0.6em;
    flex-wrap: nowrap;
    text-align: left;
    justify-content: space-between;
  }

  .plan-banner button,
  .billing-alert button {
    padding: 0.35em 0.7em;
    flex-shrink: 0;
  }
}

.habit-dots {
  display: inline-flex;
  gap: 4px;
  margin-right: 6px;
  vertical-align: middle;
}
.habit-dots i {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  border: 1.5px solid #29b1cc;
}
.habit-dots i.on {
  background: #29b1cc;
}

.plan-banner.urgent {
  background: #fff4e0;
  border-color: #f5d49a;
  color: #7a4a00;
}

.plan-banner button {
  background: #29b1cc;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 0.4em 0.9em;
  font-weight: 600;
  font-size: 0.95em;
  cursor: pointer;
  white-space: nowrap;
}

.upgrade-cta-sidebar {
  background: rgba(255, 152, 0, 0.15);
  border: 1px solid rgba(255, 152, 0, 0.4);
  border-radius: 8px;
  padding: 0.75em 1em;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 0.5em;
}

.upgrade-cta-sidebar:hover {
  background: rgba(255, 152, 0, 0.25);
  border-color: rgba(255, 152, 0, 0.6);
}

.upgrade-cta-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5em;
}

.upgrade-cta-label {
  font-size: 0.8em;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.upgrade-cta-action {
  font-size: 0.8em;
  color: #ffb74d;
  font-weight: 700;
}

.upgrade-cta-bar {
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  overflow: hidden;
  margin-bottom: 0.4em;
}

.upgrade-cta-fill {
  height: 100%;
  background: #ff9800;
  border-radius: 2px;
  transition: width 0.5s ease;
}

.upgrade-cta-count {
  font-size: 0.75em;
  color: rgba(255, 255, 255, 0.6);
  text-align: right;
}

.side-menu footer .btn-suggest {
  display: block;
  margin: 6px auto 0;
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.75);
  font-size: 0.8em;
  cursor: pointer;
}
.side-menu footer .btn-suggest:hover {
  color: #fff;
  text-decoration: underline;
}

.side-menu footer .btn-help {
  background-color: transparent;
  border: none;
  color: #fff;
  margin: 0;
  padding: 0;
}

.side-menu footer .btn-help img {
  height: 1.25em;
  margin-right: 0.35em;
  vertical-align: middle;
}

.side-menu footer .btn-help span {
  font-size: 0.95em;
  vertical-align: middle;
}

.side-menu .container-submenu {
  background-color: rgba(0, 0, 0, 0.14);
  margin: 0 10px;
  border-radius: 10px;
  height: 0;
  opacity: 0;
  overflow: hidden;

  transition: all 0.2s;
}

.side-menu .container-submenu.active {
  height: auto;
  opacity: 1;
}

.side-menu .container-submenu button {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-size: 0.9em;
  font-weight: 400;
  padding: 0.7rem 1rem 0.7rem 3.2rem;
  color: rgba(255, 255, 255, 0.82);
}

.side-menu .container-submenu button.active {
  color: #29b1cc;
  font-weight: 500;
}

.side-menu .container-submenu button:hover {
  background-color: rgba(41, 177, 204, 0.2);
  color: #29b1cc;
  transform: translateX(4px);
}

.container-group-main {
  flex: 8;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: var(--bg);
  max-width: 100vw;
}

.container-group-main header {
  display: flex;

  background-color: #fff;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  z-index: 10;
}

.container-group-main header > div {
  flex: 1;
}

.container-group-main header .col-left {
  display: inline-flex;
  align-items: center;
}

.btn-hamburguer-menu {
  background-color: transparent;
  border: none;
  height: 66px;
  flex: 0 0 52px;
  margin-right: 0.2em;
  min-height: 66px;
  padding: 0;
  width: 52px;
}

/* The icon asset is white: darken it so the menu button reads on the white header */
.btn-hamburguer-menu img {
  filter: invert(1) opacity(0.75);
  height: 1.5em;
}

.logo-ordexa {
  height: 1.25em;
}

.container-group-main header .col-right {
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.6rem;

  padding: 0 1.2rem;
}

.btn-search {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-right: 10px;
  padding: 7px 14px;
  border: 1px solid #d5e4e8;
  border-radius: 999px;
  background: #f7fbfc;
  color: #5f6f75;
  font-size: 14px;
  line-height: 1.2;
  white-space: nowrap;
  flex-shrink: 0;
  cursor: pointer;
}
.btn-search svg {
  width: 16px;
  height: 16px;
  min-width: 16px;
  flex-shrink: 0;
}
.btn-search:hover {
  border-color: #29b1cc;
  color: #127a8f;
}
@media (max-width: 640px) {
  .btn-search {
    padding: 7px 9px;
    margin-right: 6px;
  }
}

.btn-quick-note {
  background: #127a8f;
  color: #fff;
  border: none;
  border-radius: 999px;
  padding: 0.45em 1em;
  font: inherit;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.btn-quick-note:hover {
  background: #0f6878;
}

.btn-user {
  position: relative;
  display: inline-flex;
  align-items: center;

  background-color: transparent;
  border: none;
  border-radius: 100px;
  margin: 0;
  padding: 0.5em 0.75em;
  transition: all 0.2s ease;
}

/* Phones: the avatar is narrow; widen only the tap area to 44px */
@media (max-width: 767px) {
  .btn-user::after {
    content: "";
    position: absolute;
    inset: -1px -7px;
  }
}

.btn-user:hover {
  background-color: #f5f5f5;
}

.btn-user .profile-picture {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  border-radius: 100px;
  height: 1.6em;
  overflow: hidden;
  width: 1.6em;
}

.btn-user .profile-picture img {
  min-height: 1.6em;
  width: 1.6em;
  transform: scale(1.25);
}

.btn-user .user-name {
  font-size: 0.9em;
  margin: 0 0.75em;
}

.btn-user > img:last-child {
  width: 0.85em;
}

.container-user-menu {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.12);
  display: none;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  z-index: 100001;
}

.container-user-menu.active {
  display: block;
}

.container-user-menu a,
.container-user-menu button {
  display: flex;
  align-items: center;

  background-color: transparent;
  border: none;
  box-sizing: border-box;
  margin: 0;
  padding: 1em 2em 1em 1em;
  text-decoration: none;
  width: 100%;
  transition: all 0.2s ease;
}

.container-user-menu a:hover,
.container-user-menu button:hover {
  background-color: rgba(41, 177, 204, 0.1);
  transform: none;
}

.container-user-menu .container-icon {
  display: inline-block;
  text-align: center;
  width: 2.75em;
}

.container-user-menu .container-icon img {
  max-height: 1.5em;
  width: 1.75em;
}

.container-user-menu .label {
  color: buttontext;
  font-size: 0.95em;
  font-weight: 500;
}

.container-group-main .container-router-view {
  flex: 1;
  display: flex;
  flex-direction: column;

  overflow: visible;
}

.container-group-main .container-router-view :deep([id^="view-"]) {
  box-sizing: border-box;
  padding: 1.2rem;
  width: 100%;
}

/* The frame is fixed (desktop and phone): every page scrolls inside the content area
   (pages that set their own height keep it, capped to the area). On phones this also keeps
   the last 66px of each page, which used to sit under the screen edge, reachable. */
.container-group-main {
  min-height: 0;
  min-width: 0;
}
.container-group-main .container-router-view {
  min-height: 0;
  overflow: hidden;
}
.container-group-main .container-router-view > :deep([id^="view-"]) {
  max-height: 100%;
  overflow-y: auto;
  /* column: a "next step" card (onboarding) can sit above the page; the page takes the rest */
  flex: 1 1 0;
  min-height: 0;
}

.container-mobile-menu {
  background-color: #444;
  border-radius: 0 0 4px 0;
  box-shadow: 3px 3px 6px 0 rgba(0, 0, 0, 0.25);
  max-height: calc(100vh - 110px);
  overflow: auto;
  position: absolute;
  width: 85%;
  z-index: 10000;
}

.container-mobile-menu button {
  background-color: transparent;
  border: none;
  display: block;
  color: #fff;
  margin: 0;
  padding: 0;
  text-align: left;
  width: 100%;
}

.container-mobile-menu nav > button {
  display: flex;
  align-items: center;
  gap: 0.9rem;

  padding: 0.85rem 1.25rem;
  font-size: 1.02em;

  transition: all 0.2s;
}

.container-mobile-menu nav > button img,
.container-mobile-menu nav > button .m-ico {
  height: 24px;
  width: 24px;
  object-fit: contain;
  flex: none;
}
.container-mobile-menu nav > button img {
  filter: brightness(0) invert(1);
}

.container-mobile-menu .container-submenu {
  background-color: #3b3b3b;
  height: 0;
  opacity: 0;
  overflow: hidden;

  transition: all 0.2s;
}

.container-mobile-menu .container-submenu.active {
  height: auto;
  opacity: 1;
}

.container-mobile-menu .container-submenu button {
  display: flex;
  align-items: center;
  justify-content: flex-start;

  font-weight: 300;
  padding: 0.75rem 1.25rem 0.75rem 3.4rem;
}

.container-environment-id {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  background-color: #fd0;
  border-radius: 100px;
  cursor: pointer;
  font-size: 0.675em;
  font-weight: bold;
  letter-spacing: 0.015em;
  height: 2em;
  line-height: 100%;
  margin-right: 1em;
  padding: 0 1em;
  text-align: center;
  text-transform: uppercase;
}

@media (max-width: 767px) {
  #layout-default {
    overflow: auto;
  }

  /* Phones: hamburger + logo + dictate + bell + avatar have to fit in 360-390px */
  .container-group-main header .col-right {
    gap: 0.35rem;
    padding: 0 0.6rem 0 0;
  }

  .btn-quick-note {
    margin-right: 0;
  }

  .logo-ordexa {
    height: 0.95em;
  }

  .btn-hamburguer-menu {
    margin-right: 0.2rem;
  }

  /* Give the logo its own space so the search button never sits on top of it */
  .container-group-main header > .col-left {
    flex: 1 0 auto;
  }
  .container-group-main header > .col-right {
    flex: 0 0 auto;
    margin-left: 8px;
  }

  .btn-search {
    min-height: 44px;
    min-width: 44px;
    justify-content: center;
  }

  .container-group-main header .col-right > .bell {
    margin-right: 0;
  }

  .container-group-main header .btn-user {
    padding-left: 4px;
    padding-right: 0;
  }

  /* The avatar alone opens the menu; the arrow and spacing pushed it off 390px screens */
  .container-group-main header .btn-user .profile-picture {
    margin-right: 0;
  }
  .container-group-main header .btn-user > img:last-child {
    display: none;
  }

  .btn-search {
    margin-right: 0;
    padding: 7px;
  }

  .btn-quick-note {
    padding: 0.45em 0.8em;
  }
}

@media (min-width: 768px) and (max-width: 1199px) {
}

@media (max-width: 1199px) {
  .btn-user .profile-picture {
    margin-right: 0.5em;
  }
}

@media (min-width: 1200px) {
}
</style>
